// import axios from 'axios'
import Vue from 'vue'
import axios from 'axios'

const ComponentTicketServiceHelper = {
  methods: {
    /**
     * @param {String} revertActionUrl
     * @param {String} message
     * @return Void
     */
    captureDataUpdateStatusRevert(revertActionUrl, message) {
      const { id, estado_usuario_id } = this.ticket

      this.captureDataToRevert('update_ticket', [{ id, columns: [{ column: 'estado_usuario_id', value: estado_usuario_id }] }], message, revertActionUrl)
    },
    /**
     * @param String url
     * @param String status
     * @return Void
     */
    async updateTicketStatusModule(url, status) {
      const _this = this
      if (!_this.checkVariable(_this.ticketStatusForm)) {
        return null
      }

      _this.defaultSettingsSwal()
      const swal = _this.setupSwal()

      return swal.fire({
        title: 'Deje un comentario',
        text: '',
        input: 'textarea',
        inputPlaceholder: 'Comentario',
        inputAttributes: {
          'aria-label': 'Escribe tu comentario aquí',
        },
        showCancelButton: true,
        preConfirm: value => {
          _this.$set(_this.ticketStatusForm, 'estado_usuario_id', status)
          _this.$set(_this.ticketStatusForm, 'comentario', value)

          return _this.ticketStatusForm.patch(url)
        },
      }).then(async response => {
        if (_this.checkVariable(response) && _this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          _this.defaultSettingsToastSwal()
          _this.swalTitle = _this.$t('update_response')
          _this.swalText = undefined
          _this.positionedDialogToast()
          _this.$root.$emit('triggerSwitchRevertDataToast', true)
          _this.$store.dispatch('setUpdateStatus', _this.generateRandomNumber(10))
        }

        return response
      })
    },
    /**
     * @param {String} revertActionUrl
     */
    captureDataCreationCommentRevert(revertActionUrl) {
      const { id } = this.ticket

      this.captureDataToRevert('create_comentario_ticket', [{ id, relatedTables: [{ relation: 'comentarios', action: 'delete' }] }], 'Eliminar comentario creado.', revertActionUrl)

      this.$root.$emit('triggerSwitchRevertDataToast', true)
    },
    /**
     * @param String actionUrl
     * @param Object formData
     * @param String revertActionUrl
     * @return Promise
     */
    reassignUserTicket(actionUrl, formData, revertActionUrl) {
      const { id, asignado_id: asignado_anterior_id } = this.ticket
      if (!this.checkVariable(id)) {
        return null
      }

      const asignado_id = this.getObjectValue(formData, 'asignado_id.value')
      const message = 'Se actualizó el Usuario asignado.'
      this.captureDataToRevert('reasignar_usuario_ticket', [{ id, columns: [{ column: 'asignado_id', value: asignado_anterior_id }] }], message, revertActionUrl)
      const promise = axios.patch(actionUrl, { asignado_id })
      promise.then(() => {
        this.$root.$emit('triggerSwitchRevertDataToast', true)
        this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
      }).catch(err => {
        return err
      })

      return promise
    },
  },
}

const Component = Vue.extend({
  name: 'new-ticket-service-helper',
  mixins: [ComponentTicketServiceHelper],
})

export default Component
